import { gsap } from "gsap";

const ClientsBox = () => {
	const block = document.querySelectorAll(".clients-box");
	if (!block) {
		return;
	}
	let mm = gsap.matchMedia();

	block.forEach((el) => {
		const logos = el.querySelector(".clients-box__logos");
		const logosWrap = el.querySelector(".clients-box__logos-wrap");
		let inited = false;
		let tl = gsap.timeline();

		const initTicker = () => {
			tl.to(logosWrap, {
				x: logos.offsetWidth,
				repeat: -1,
				duration: 50,
				ease: "none"
			});
		};

		mm.add("(max-width: 767px)", () => {
			if (inited) {
				initTicker();
				tl.play();
			} else {
				logosWrap.append(logos.cloneNode(true));
				el.querySelector(".clients-box__logos:last-child").classList.add("clients-box__logos_cloned");

				initTicker();
				inited = true;
			}
		});
		mm.add("(min-width: 768px)", () => {
			if (inited) {
				tl.pause(0);
			}
		});
	});
};

export default ClientsBox;
